/* eslint-disable */
import $ from 'jquery';

export default {
    init() {
      
    },
    finalize() {

        $(document).ready(function(){
            $.ajax({
                data: {
                    action: 'getRisk',
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    $('h1').html(response);
                }
            })
        })

        $('.advice').click(function(){
            // $('.advice').not(this).next('.items-list').hide();
            // $('.advice').not(this).find('.arrow').removeClass('-rotate-90');
            $(this).next('.items-list').slideToggle();

            if($(this).find('.arrow').hasClass('-rotate-90')){
                $(this).find('.arrow').removeClass('-rotate-90');
            } else {
                $(this).find('.arrow').addClass('-rotate-90');
            }
        })
          
        $('#print').click(function(){
            $('.advice').next('.items-list').show();

            window.print()
            
            $('.advice').next('.items-list').hide();
            
        })
        
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/self-audit-diagnosis.js